import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components';

export const wizardButtonContainer = (disabled: boolean) => css`
  width: 238px;
  display: flex;
  position: relative;
  justify-content: start;
  border: 1px solid ${colors.gray.light};
  color: ${colors.gray.dark};
  background-color: ${disabled ? colors.custom.lightestGray50 : colors.white} !important;
  box-shadow: 2px 2px 10px ${colors.shadows.default};

  font-weight: ${fonts.weight.medium};

  svg {
    width: ${icons.size.small};
    height: ${icons.size.small};
  }

  svg:first-child {
    color: ${disabled ? colors.gray.default : colors.primary.default} !important;
  }

  :disabled {
    border: 1px solid ${colors.gray.light} !important;
    background-color: ${colors.custom.transparent} !important;
    color: ${colors.gray.dark} !important;
    box-shadow: none !important;
  }

  :disabled svg:first-child {
    color: ${colors.gray.default} !important;
  }

  :hover {
    background-color: ${colors.gray.lightest};
  }
`;

export const endIcon = css`
  flex-grow: 1;
  position: absolute;
  right: 8px;
`;

export const endIconColored = css`
  color: ${colors.primary.default} !important;
  flex-grow: 1;
  position: absolute;
  right: 8px;
`;
